'use client';
import dynamic from 'next/dynamic';
import SXMLink from '@/shared-components/SXMLink';
import { LinkInfoItem } from '@/components/molecules/LinkInfoCard';
const Button = dynamic(() => import('de-sxm-reactlib-2/components/atoms/Button/Button'));
import { ButtonVariants } from 'de-sxm-reactlib-2/components/atoms/Button/Button';
import { useEffect, useState } from 'react';

interface Props {
    type: LinkType | undefined;
    variant?: ButtonVariants;
    bgColor?: string;
    text: string | undefined;
    iconUrl?: string;
    iconWidth?: number;
    iconHeight?: number;
}

export default function ChatLink({
    type,
    variant = 'tertiary',
    bgColor,
    text,
    iconUrl,
    iconHeight,
    iconWidth,
}: Props): React.JSX.Element {
    const [component, setComponent] = useState(<></>);

    useEffect(() => {
        const clientWindow = window as BrowserWindow;

        function openChat(e: React.MouseEvent) {
            e.preventDefault();
            if (clientWindow && clientWindow.sierraSXM) {
                clientWindow.sierraSXM.openChatModal();
            }
        }

        if (type) {
            if (type.indexOf('CTA') >= 0) {
                setComponent(
                    <Button
                        type="button"
                        variant={variant}
                        color={bgColor}
                        onClick={openChat}
                        tertiaryNoPadding={variant === 'tertiary'}
                    >
                        {text}
                    </Button>,
                );
            } else if (type === 'Text') {
                setComponent(
                    <SXMLink href="" onClick={openChat}>
                        {text}
                    </SXMLink>,
                );
            } else if (type === 'LinkInfoCard') {
                setComponent(
                    <LinkInfoItem
                        link={{
                            link_text: text,
                        }}
                        disabled={false}
                        onClick={openChat}
                        icon={{ url: iconUrl, width: iconWidth, height: iconHeight }}
                    />,
                );
            }
        }
    }, [bgColor, iconUrl, iconHeight, iconWidth, text, variant, type]);

    return component;
}
